import {
    PROPOSAL_BUSY,
    PROPOSAL_ERROR,
    PROPOSAL_CLEAR,
    PROPOSAL_SAVED,
    PROPOSAL_CREATED,
    PROPOSAL_RETRIEVED,
    PROPOSAL_LIST_RETRIEVED,
    PROPOSAL_DELETED,
    TIL_BEHANDLING_STATUS,
    EMAIL_ERROR,
    PROPOSAL_FILE_ADDED,
    PROPOSAL_FILE_DELETE,
} from '../constants/actions';

const initialState = {
    success: null,
    fetching: false,
    error: '',
    proposal: {
        GeneralData: {},
    },
    proposalList: [],
};
const TIL_BEHANDLING_CODE = '1';

export default function proposalReducer(state = initialState, action) {
    switch (action.type) {
        case PROPOSAL_BUSY:
        return Object.assign({}, state, {
            fetching: true,
            success: null,
            error: '',
        });
        case PROPOSAL_ERROR:
        return Object.assign({}, state, {
            fetching: false,
            success: null,
            error: action.payload,
        });
        case EMAIL_ERROR:
        return Object.assign({}, state, {
            fetching:false,
            success: null,
            error: action.payload,
        });
        case TIL_BEHANDLING_STATUS: {
            let theProposal = {...state.proposal};
            theProposal.Status1 = TIL_BEHANDLING_CODE;
            return Object.assign({}, state, {
                fetching: false,
                success: TIL_BEHANDLING_STATUS,
                error: '',
                proposal: theProposal,
            });
        }
        case PROPOSAL_CLEAR:
        return {...state,
            fetching: false,
            error: '',
            success: null,
            proposal: { GeneralData: {}},
        };

        case PROPOSAL_DELETED:
        return {...state,
            fetching: false,
            success: PROPOSAL_DELETED,
            proposal: {},
            proposalList: state.proposalList.filter((item) => {
                return item.Id !== action.payload;
            }),
        };

        case PROPOSAL_RETRIEVED:
        return Object.assign({}, state, {
            fetching: false,
            proposal: {...action.payload},
        });
        case PROPOSAL_LIST_RETRIEVED:
        return Object.assign( {}, state, {
            fetching: false,
            proposalList: [...action.payload],
        });
        case PROPOSAL_SAVED:
        return Object.assign({}, state, {
            fetching: false,
            success: PROPOSAL_SAVED,
            proposal: {...action.payload},
            // proposalList: state.proposalList.map( (item) => {
            //     if(item.Id === action.payload.Id) {
            //         return {...item, ...action.payload};
            //     }
            //     return item;
            // }),
        });
        case PROPOSAL_CREATED:
        return Object.assign({}, state, {
            fetching: false,
            success: PROPOSAL_CREATED,
            proposal: {...action.payload},
            proposalList: [...state.proposalList,{...action.paylod}],
        });

        case PROPOSAL_FILE_ADDED:
        return {...state,
            proposal: {...state.proposal,
                Attachments: [...state.proposal.Attachments, action.payload],
            },
        };

        case PROPOSAL_FILE_DELETE:
        return {...state,
            proposal: {...state.proposal,
                Attachments: state.proposal.Attachments.filter((a) => a !== action.payload),
            },
        };

        default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/proposal.js